import React from "react";
import { Icon } from "@iconify/react";
import { Link } from "react-router-dom";
import Banner from "../assets/images/eventbanner.webp";

function Events(props) {
  return (
    <div className="md:w-1/3">
      <div className="p-6 h-full overflow-hidden">
        <img
          className="web-box-shadow lg:h-100 w-full object-cover object-center"
          src={require("../assets/images/" + props.featimage + ".png")}
          alt="blog"
        />
        <div className="py-6">
          <h2 className="text-xs title-font text-0E7090 font-semibold mb-1">
            Virtual
          </h2>
          <div className="flex">
            <h1 className="title-font w-10/12 text-2xl font-semibold text-101828 mb-3 inline-block">
              {props.heading}
            </h1>
            <Icon
              icon="akar-icons:arrow-up-right"
              className="inline-block"
              color="#101828"
              width="24"
              height="24"
            />
          </div>
          <p className="leading-relaxed mb-3 text-sm">
            {props.featuring} <br />
            <b>{props.guest}</b>
            <br />
            {props.past}
          </p>
          <p className="text-101828 text-sm font-semibold my-8">
            {props.date} <br />
            {props.time}
          </p>
          <div className="flex items-center flex-wrap ">
            <Link to={`/register/${props.heading}`}>
              <button className="inline-flex items-center bg-088AB2 border-0 py-2 px-4 focus:outline-none hover:bg-gray-200 rounded-8 text-white mt-4 md:mt-0">
                {!props.done ? "Register Now" : "Watch Now"}
              </button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Events;
